export const PARCEL_MAPPING: Record<number, string> = {
    111: '389,310,415,350,447,331,464,354,504,323,453,259',
    128: '273,653,372,596,339,548,319,555,303,550',
    142: '229,430,270,488,322,450,282,391',
    156: '897,230,930,270,999,221,966,180',
};
